import React from "react";
import {
    Text,
    TableContainer,
    Table,
    Thead,
    Th,
    Tbody,
    Tr,
    Td
} from "@chakra-ui/react";
import Count from "./reports/Count";

const BasicCountTable = ({ type, reportsMatrix }) => {

    return (
        <TableContainer whiteSpace={{ base: "nowrap", xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap" }}>
            <Table size={{ base: 'md', xs: 'xs', sm: 'sm', md: 'md', lg: 'lg' }}>
                <Thead>
                    <Tr>
                        <Th sx={{ borderColor: 'gray.300' }}>Stage</Th>
                        <Th isNumeric sx={{ borderColor: 'gray.300' }}>Count</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {reportsMatrix.map((report, index) => (
                        <Tr key={`${type}-${report.module}-tr-${index}`}>
                            <Td key={`${report.module}-td-title-${index}`} sx={{ paddingTop: '10px !important', paddingBottom: '10px !important', borderColor: 'blue.600' }} >
                                <Text>{report.title}</Text>
                            </Td>
                            <Td key={`${type}-${report.module}-td-count-${index}`} isNumeric sx={{ paddingTop: '10px !important', paddingBottom: '10px !important', borderColor: 'blue.600' }} >
                                <Count module={report.module} {...(Object.hasOwn(report, "query") ? { query: report.query } : {})} />
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
};

export default BasicCountTable;